import { classApi } from '@/api';

const state = {
  year: localStorage.getItem('globyear') ? Number(localStorage.getItem('globyear')) : '',
  term: localStorage.getItem('globterm') ? Number(localStorage.getItem('globterm')) : '',
  classType: localStorage.getItem('globclasstype') ? Number(localStorage.getItem('globclasstype')) : '',
  list: {
    year: [],
    term: []
  },
  isShow: false
};

const mutations = {
  CHANGE_YEAR(state, playload) {
    state.year = playload;
    localStorage.setItem('globyear', playload);
  },
  CHANGE_TERM(state, playload) {
    state.term = playload;
    localStorage.setItem('globterm', playload);
  },
  CHANGE_CLASSTYPE(state, playload) {
    state.classType = playload;
    localStorage.setItem('globclasstype', playload);
  },
  CHANGE_SHOW(state, playload) {
    state.isShow = playload;
  },
  CHANGE_LIST(state, playload) {
    state.list = playload;
  }
};
const actions = {
  changeYear({ commit }, playload) {
    commit('CHANGE_YEAR', playload);
  },
  changeTerm({ commit }, playload) {
    commit('CHANGE_TERM', playload);
  },
  changeClassType({ commit }, playload) {
    commit('CHANGE_CLASSTYPE', playload);
  },
  changeShow({ commit }, playload) {
    commit('CHANGE_SHOW', playload);
  },
  async getTermAndYearList({ commit, state }) {
    if (state.list.year.length && state.list.term.length) {
      return state.list;
    }
    const values = await Promise.all([classApi.year(), classApi.termChoose()]);
    const { data } = values[1] || {};
    const playload = {
      year: values[0] ? values[0].data : [],
      term: values[1] ? [data[data.length - 1], ...data.slice(0, data.length - 1)] : []
    };
    commit('CHANGE_LIST', playload);
    return playload;
  }
};

const schoolYear = {
  namespaced: true,
  state,
  mutations,
  actions
};

export default schoolYear;
